const currencyList = ['USD', 'GBP', 'EUR', 'AUD'];
const manageList = ['TECHNICIAN', 'NETWORK_ASSET'];

const getFilteredCurrencies = (currency) => {
  const filteredCurrency = currency.filter((el) =>
    currencyList.includes(el.currencyCode)
  );
  return filteredCurrency;
};

const planDescriptionKeyMap = {
  'Standard-PSA': 'app.pricing.standard.psa.description',
  'Standard-PSA-2024': 'app.pricing.standard.psa.description',
  'Standard-RMM': 'app.pricing.standard.rmm.description',
  'Standard-RMM-2024': 'app.pricing.standard.rmm.description',
  Pro: 'app.pricing.pro.description',
  'Pro-2024': 'app.pricing.pro.description',
  Super: 'app.pricing.super.description',
  'Super-2024': 'app.pricing.super.description',
  Prime: 'itsm.app.pricing.prime.description',
  DEFAULT: 'app.pricing.super.description',
  Prime_Plus: 'itsm.app.pricing.prime.description',
  Super_Plus: 'app.pricing.super.description'
};

const oldNewPlanOrderIdMapping = {
  Rise: null,
  Grow: 'Standard-PSA',
  Connect: 'Standard-RMM',
  Ultra: 'Pro',
  'Standard-PSA': 'Standard-RMM',
  'Standard-RMM': 'Standard-RMM',
  Pro: 'Pro',
  Super: 'Super',
  'Standard-PSA-2024': 'Standard-RMM-2024',
  'Standard-RMM-2024': 'Standard-RMM-2024',
  'Pro-2024': 'Pro-2024',
  'Super-2024': 'Super-2024'
};

const oldNewPlanOrderIdMappingFlag = {
  Rise: null,
  Grow: 'Standard-PSA-2024',
  Connect: 'Standard-RMM-2024',
  Ultra: 'Pro-2024',
  'Standard-PSA': 'Standard-RMM-2024',
  'Standard-RMM': 'Standard-RMM-2024',
  Pro: 'Pro-2024',
  Super: 'Super-2024',
  'Standard-PSA-2024': 'Standard-RMM-2024',
  'Standard-RMM-2024': 'Standard-RMM-2024',
  'Pro-2024': 'Pro-2024',
  'Super-2024': 'Super-2024',
  Prime: 'Prime',
  Prime_Plus: 'Prime_Plus',
  Super_Plus: 'Super_Plus'
};

const restrictUpgradeOldPlans = [
  'Standard-PSA',
  'Standard-RMM',
  'Super',
  'Pro',
  'Ultra',
  'Grow',
  'Rise',
  'Connect'
];

const oldNewPlanNameMapping = {
  Rise: null,
  Grow: 'Standard-PSA',
  Connect: 'Standard-RMM',
  Ultra: 'Pro',
  'Standard-PSA': 'Standard-PSA',
  'Standard-RMM': 'Standard-RMM',
  Pro: 'Pro',
  Super: 'Super',
  'Standard-PSA-2024': 'Standard-PSA-2024',
  'Standard-RMM-2024': 'Standard-RMM-2024',
  'Pro-2024': 'Pro-2024',
  'Super-2024': 'Super-2024',
  NFR: 'Super'
};

const addOnMapping = {
  TECHNICIAN: { enabled: true, purchased: true },
  ALL_ASSET: { enabled: true, purchased: true },
  END_POINT_ASSET: 'WINDOWS_MANAGEMENT',
  NETWORK_ASSET: 'network-monitoring-system',
  MDM_ASSET: 'MDM'
};

const INVOICE_TABLE_HEADERS = [
  {
    label: 'Date',
    accessor: 'date',
    type: 'DateTime',
    id: 'date'
  },
  {
    label: 'Technician License',
    accessor: 'licenseQuantity',
    type: 'Text',
    id: 'licenseQuantity'
  },
  {
    label: 'Device License',
    accessor: 'licenseQuantity',
    type: 'Text',
    id: 'licenseQuantity'
  },
  {
    label: 'End Points Pack',
    accessor: 'addonQuantity',
    type: 'Text',
    id: 'addonQuantity'
  },
  {
    label: 'Total',
    accessor: 'total',
    type: 'MSPCurrency',
    id: 'total'
  },
  {
    label: 'Status',
    accessor: 'status',
    type: 'STATUS',
    id: 'status'
  }
];

export {
  oldNewPlanOrderIdMapping,
  oldNewPlanOrderIdMappingFlag,
  getFilteredCurrencies,
  manageList,
  planDescriptionKeyMap,
  INVOICE_TABLE_HEADERS,
  oldNewPlanNameMapping,
  addOnMapping,
  restrictUpgradeOldPlans
};
